import { createClient } from 'contentful';
import { INLINES } from '@contentful/rich-text-types';

const apiKey = process.env.REACT_APP_CONTENTFUL_API_KEY;
const spaceID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const SPACE_ID = spaceID
const ACCESS_TOKEN = apiKey;
const ENVIRONMENT = 'master'

const client = createClient({
    space: SPACE_ID,
    accessToken: ACCESS_TOKEN,
    environment: ENVIRONMENT
})

export const renderOptions = {
    renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
            const url = node.data.uri;
            return (
                <a
                    href={url}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: 'white', textDecoration: 'underline' }}
                >
                    {children}
                </a>
            );
        },
    },
};

export default client;